export default {
  SUPPLIERS_LIST: "Suppliers list",
  ADD_SUPPLIER: "Add supplier",
  SUPPLIER_ADDED: "Supplier added",
  EDIT_SUPPLIER: "Edit supplier",
  SUPPLIER_UPDATED: "Supplier updated",
  DELETE_THIS_SUPPLIER: "Delete this supplier?",
  SUPPLIER_DELETED: "Supplier deleted",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  ACTIVATE: "Activate",
  DEACTIVATE: "Deactivate",
  SUPPLIER_ACTIVATED: "Supplier Activated",
  SUPPLIER_DEACTIVATED: "Supplier Deactivated",
  ADD_TO_WAREHOUSES: "Add to warehouses",
  DELETE_FROM_WAREHOUSES: "Remove from warehouses",
  PURCHASE_TAX_SETTINGS: "Purchase Tax Settings",
  PURCHASE_TAX_SETTINGS_HELP: "Check the charges this supplier bills GST and QST on. Applied to charges added when generating a purchase invoice.",
  REFRESH_PRICES: "Refresh prices",
  REFRESH_PRICES_CONFIRM_TITLE: "Refresh warehouse prices?",
  REFRESH_PRICES_CONFIRM_MESSAGE: "All warehouse product prices will be updated from the product prices.<br><br><strong>Products with custom pricing will NOT be updated.</strong>",
  REFRESH_PRICES_RESULTS: "Price refresh results",
  PRICES_UPDATED: "Prices updated",
  BUYING_PRICES_UPDATED: "Buying prices updated",
  SELLING_PRICES_UPDATED: "Selling prices updated",
  PRODUCTS_PROCESSED: "Products processed",
  PRODUCT: "Product",
  PRODUCTS_WARNINGS: "Warnings",
  WARNING: "Warning",
};
